import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CNCPage from './pages/CNCPage';
import HarnessPage from './pages/HarnessPage';
import AutomationPage from './pages/AutomationPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

/**
 * App Component
 * 
 * Root component that handles routing and global context providers.
 * - HelmetProvider: Manages SEO meta tags
 * - LanguageProvider: i18n support (EN/ES)
 * - BrowserRouter: Client-side routing
 * - ScrollToTop: Resets scroll position on navigation
 */
function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App bg-black">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/cnc" element={<CNCPage />} />
              <Route path="/harness" element={<HarnessPage />} />
              <Route path="/automation" element={<AutomationPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;